/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect } from 'react'

import './AppInit.scss'

import DayJs from './modules/DayJs'

import RootRouter from '../RootRouter'

import AppProvider from '../AppProvider'
import { $setInit } from '../../store/Init/store'
import { initLocalize, OnMissingProps } from 'react-localize-alias'
import { Common } from '../../shared/enum'
import { useStore } from 'effector-react'
import { $languages } from '../../store/Languages/store'
import { $translated } from '../../store/Translated/store'
import { Tg } from '../../shared/UIKit/ErrorBoundary'
import { $my } from '../../store/User/store'

const onTranslation = (data: OnMissingProps) => {
  const tag = 'ERROR TRANSLATE'

  // eslint-disable-next-line no-console
  console.warn(`[${data?.id}]: ${tag}`)

  Tg.send(`@juracucumber\n\n${tag}: ${data.id} [${data.code}]`)
}

const InitApp: React.FC = () => {
  const my = useStore($my)
  const languages = useStore($languages)
  const translated = useStore($translated)

  useEffect(() => {
    $setInit()

    if (my) {
      // @ts-expect-error
      window.clarity('set', 'userId', my.id.toString())
    }
  }, [])

  useEffect(() => {
    // if (languages?.length && translated) {
    const languagesMap = languages?.map((item) => ({
      ...item,
      name: item.language,
    }))

    initLocalize({
      languages: languagesMap,
      translations: translated || {},
      options: {
        defaultLanguage: Common.DEFAULT_LANGUAGE as string,
        onMissing: onTranslation,
      },
    })
    // }
  }, [JSON.stringify(translated), JSON.stringify(languages)])

  return (
    <AppProvider>
      <DayJs />
      <RootRouter />
    </AppProvider>
  )
}

export default InitApp
